import { graphql } from 'gatsby'
import React from 'react'

import WorldCupLocator, {
  WorldCupLocatorContent,
} from 'src/components/organisms/restaurantLocator/worldCupLocator'

type Props = {
  slice: any // todo rp: replace with generated type
}

const WorldCupLocatorSlice = ({ slice }: Props) => {
  const content: WorldCupLocatorContent = {
    anchor: slice.primary.anchor ?? undefined,
    callout: slice.primary.callout ?? undefined,
    link: slice.primary.link ?? undefined,
    linkText: slice.primary.link_text ?? undefined,
  }

  return <WorldCupLocator content={content} />
}

export default WorldCupLocatorSlice

export const fragmentQuery = graphql`
  fragment PageDataBodyWorldCupLocator on PrismicPageDataBodyWorldCupLocator {
    primary {
      anchor
      callout
      link_text
      link {
        ...BasicLinkFragment
      }
    }
  }
`
